"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumBannerData = void 0;
const actions_1 = require("./actions");
const tracking_utils_1 = require("../../crossellModule/tracking/tracking.utils");
const pathName = window.location.pathname;
exports.TealiumBannerData = {
    [actions_1.LATERAL_BANNER_VIEW]: ({ title, feedback }) => ({
        action: actions_1.TealiumAction.VIEW,
        format: actions_1.TealiumFormat.BANNER,
        component: actions_1.TealiumComponent.BANNER,
        element: 'full',
        eventCategory: (0, tracking_utils_1.getEventCategory)(window.location.pathname),
        eventAction: 'viewBanner',
        eventLabel: 'full',
        tealium_event: 'product_impression',
        product_name: [`${title}`],
        product_position: ['1'],
        atActivity: feedback?.activityId,
        atOffer: feedback?.offerId,
        atExperience: feedback?.experienceId,
        atTrafficAllocation: feedback?.trafficAllocationId,
    }),
    [actions_1.LATERAL_BANNER_CLICK_BUTTON]: ({ title, feedback }) => ({
        action: actions_1.TealiumAction.OPEN,
        format: actions_1.TealiumFormat.BUTTON,
        component: actions_1.TealiumComponent.BANNER,
        element: 'knowMore',
        pathname: pathName,
        eventCategory: (0, tracking_utils_1.getEventCategory)(pathName),
        eventAction: actions_1.TealiumEventAction.CLICK_BUTTON,
        eventLabel: 'knowMoreButton',
        tealium_event: 'product_click',
        product_name: [`${title}`],
        product_position: ['1'],
        atActivity: feedback?.activityId,
        atOffer: feedback?.offerId,
        atExperience: feedback?.experienceId,
        atTrafficAllocation: feedback?.trafficAllocationId,
    }),
};
//# sourceMappingURL=tealium.js.map